import React from "react";
import { IOnGoingTrip } from "@types";

interface PublicHeaderProps {
  detail?: IOnGoingTrip | null;
}

export const PublicHeader: React.FC<PublicHeaderProps> = ({ detail }) => (
  <div className="display-flex align-items-center padding-y-20" style={{ marginLeft: 6, marginBottom: 4 }}>
    <span className="rioglyph rioglyph-truck text-size-h1"></span>
    <span className="text-bold text-size-18">{detail?.assetName}</span>
  </div>
);